import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { captureInviteHashType, captureRecoveryHashType } from './lib/authInvitePasswordPending'
import { initSentry } from './lib/sentry'
import { App } from './App.tsx'

try {
  initSentry()
} catch (e) {
  console.warn('[sentry] init failed', e)
}

captureInviteHashType()
captureRecoveryHashType()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
